module.exports = __webpack_public_path__ + "static/quotations-c0857e34466515622ed61df3ced320c0.jpg";